/*globals DOMTokenList */

// element.classList polyfill
// Based upon: classList.js: Cross-browser full element.classList implementation. 2014-07-23. By Eli Grey, http://eligrey.com Public Domain.
// For: IE 11

(function() {
  // Normalize the add/remove and toggle APIs
  let testElement = document.createElement('_');

  testElement.classList.add('c1', 'c2');

  // Polyfill for IE 10/11 and Firefox <26, where classList.add and classList.remove exist but support only one argument at a time.
  if (!testElement.classList.contains('c2')) {
    const createMethod = function(method) {
      const original = DOMTokenList.prototype[method];

      DOMTokenList.prototype[method] = function(token) {
        const len = arguments.length;
        let i;

        for (i = 0; i < len; i++) {
          token = arguments[i];
          original.call(this, token);
        }

      };

    };

    createMethod('add');
    createMethod('remove');
  }

  testElement.classList.toggle('c3', false);

  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not support the second argument.
  if (testElement.classList.contains('c3')) {
    const _toggle = DOMTokenList.prototype.toggle;

    DOMTokenList.prototype.toggle = function(token, force) {
      return (1 in arguments && !this.contains(token) === !force) ? force : _toggle.call(this, token);
    };
  }

  testElement = null;

}());



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/polyfills/element-classlist-for-ie11.js